import { BodyMeasurements } from "../models/users/bodyMeasurements.ts";
import { ChangePasswordModel } from "../models/users/changePasswordModel.ts";
import { UserGoals } from "../models/users/userGoals.ts";
import { UserLoginModel } from "../models/users/userLoginModel.ts";
import { UserRegisterModel } from "../models/users/userRegisterModel.ts";
import { UserRepresentation } from "../models/users/userRepresentation.ts";
import { ApiClient } from "./ApiClient";
const UsersController = {
    register: (userRegisterModel: UserRegisterModel) => {
        return ApiClient.post('register', userRegisterModel);
    },
    login: (userLoginModel: UserLoginModel) => {
        return ApiClient.post('login', userLoginModel);
    },
    changePassword: (changePasswordModel: ChangePasswordModel) => {
        const refreshToken = localStorage.getItem('refreshToken') || '';
        return ApiClient.patch('profile/change-password', { ...changePasswordModel, refreshToken });
    },
    logout: () => {
        const userID = localStorage.getItem('userID');
        const refreshToken = localStorage.getItem('refreshToken') || '';
        return ApiClient.post('logout', { userID, refreshToken })
    },
    getProfile: () => {
        return ApiClient.get('profile');
    },
    updateProfile: (userRepresentation: UserRepresentation) => {
        return ApiClient.put('profile', userRepresentation);
    },
    postBodyMeasurements: (bodyMeasurements: BodyMeasurements) => {
        return ApiClient.post('profile/body-measurements', bodyMeasurements);
    },
    postUserGoals: (userGoals: UserGoals) => {
        return ApiClient.post('profile/user-goals', userGoals);
    }
};
export default UsersController;